import React from 'react';
import styled from 'styled-components';

import './waves.css';

const WavesSVG = styled.svg`
	position: relative;
	width: 100%;
	height: 15vh;
	min-height: 100px;
	max-height: 150px;
	margin-top: auto;
`;

export const Waves = () => {
	return (
		<WavesSVG
			xmlns='http://www.w3.org/2000/svg'
			xmlnsXlink='http://www.w3.org/1999/xlink'
			viewBox='0 24 150 28'
			preserveAspectRatio='none'
			shape-rendering='auto'
		>
			<defs>
				<path
					id='gentle-wave'
					d='M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z'
				/>
			</defs>
			<g className='parallax'>
				<use
					xlinkHref='#gentle-wave'
					x='48'
					y='0'
					fill='rgba(25, 172, 113, 0.7'
				/>
				<use
					xlinkHref='#gentle-wave'
					x='48'
					y='3'
					fill='rgba(25, 172, 113, 0.5)'
				/>
				<use
					xlinkHref='#gentle-wave'
					x='48'
					y='5'
					fill='rgba(25, 172, 113, 0.3)'
				/>
				<use
					xlinkHref='#gentle-wave'
					x='48'
					y='7'
					fill='rgb(25, 172, 113)'
				/>
			</g>
		</WavesSVG>
	);
};
